import React, { useState, useEffect, useCallback } from "react";
import { supabase } from "../../supabaseClient";
// import ShieldImg from "../../Assets/Icons/shield.png";
import LoaderBox from "./LoaderBox";

const DANI_LISTA = [
  "Uto 23.6.",
  "Sri 24.6.",
  "Čet 25.6.",
  "Pet 26.6.",
  "Sub 27.6.",
];

const HomeRaspored = () => {
  const [activeDan, setActiveDan] = useState(DANI_LISTA[0]);
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hideDataMode, setHideDataMode] = useState(false);
  const [isAutoScrolling, setIsAutoScrolling] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.has("highlight"); // true ako je highlight u URL-u
  });

  const fetchMatches = useCallback(async () => {
    setLoading(true);
    try {
      // ================= POPRAVLJENO ZA TVOJU STRUKTURU TABLICE =================
      const { data: settings } = await supabase
        .from("site_settings")
        .select("prikazi_raspored")
        .eq("id", 1)
        .single();

      const rasporedJeVidljiv = settings ? settings.prikazi_raspored : false;

      if (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
      ) {
        setHideDataMode(false);
      } else {
        setHideDataMode(!rasporedJeVidljiv);
      }
      // ===========================================================================

      const { data, error } = await supabase
        .from("matches")
        .select(
          `
          *,
          team_a:team_a_id(name, logo_url),
          team_b:team_b_id(name, logo_url)
        `,
        )
        .order("match_time", { ascending: true });

      if (error) throw error;

      setMatches(data || []);

      // --- NOVA LOGIKA: Provjera highlighta u URL-u ---
      const queryParams = new URLSearchParams(window.location.search);
      const highlight = queryParams.get("highlight");

      if (highlight) {
        const targetTeam = decodeURIComponent(highlight);
        // Tražimo utakmicu u kojoj sudjeluje traženi tim
        const match = data.find(
          (m) => m.team_a?.name === targetTeam || m.team_b?.name === targetTeam,
        );

        if (match) {
          setActiveDan(match.match_day);
        } else {
          // Fallback ako ne nađe tim
          setActiveDan(DANI_LISTA[0]);
        }
      } else {
        // --- STARA LOGIKA (ako nema highlighta) ---
        const danSPreostalimUtakmicama = DANI_LISTA.find((dan) =>
          data.some((m) => m.match_day === dan && !m.is_completed),
        );

        if (danSPreostalimUtakmicama) {
          setActiveDan(danSPreostalimUtakmicama);
        } else {
          setActiveDan(DANI_LISTA[DANI_LISTA.length - 1]);
        }
      }
    } catch (err) {
      console.error("Greška pri dohvaćanju rasporeda:", err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const handleUrlChange = () => {
      const params = new URLSearchParams(window.location.search);
      if (params.has("highlight")) {
        setIsAutoScrolling(true);
      }
    };

    window.addEventListener("urlChanged", handleUrlChange);
    return () => window.removeEventListener("urlChanged", handleUrlChange);
  }, []);

  useEffect(() => {
    if (!isAutoScrolling || loading || matches.length === 0) return;

    const queryParams = new URLSearchParams(window.location.search);
    const highlight = queryParams.get("highlight");
    if (!highlight) return;

    const highlightTeam = decodeURIComponent(highlight);
    const matchToScroll = matches.find(
      (m) =>
        m.team_a?.name === highlightTeam || m.team_b?.name === highlightTeam,
    );

    if (matchToScroll) {
      if (matchToScroll.match_day !== activeDan) {
        setActiveDan(matchToScroll.match_day);
        // Vraćamo se iz ove funkcije jer promjena activeDan
        // triggera novi render, pa će ovaj isti useEffect
        // ponovno pozvati kod čim se renderira novi dan
        return;
      }

      // Skrolaj
      setTimeout(() => {
        const element = document.getElementById(`match-${matchToScroll.id}`);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          element.classList.add("highlight-flash");
          setTimeout(() => element.classList.remove("highlight-flash"), 2000);
        }

        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
        setIsAutoScrolling(false); // ISKLJUČI AUTO-SCROLL NAKON ŠTO ODSKROLAŠ
      }, 150);
    } else {
      setIsAutoScrolling(false); // Nema utakmice, isključi auto-scroll
    }
  }, [loading, matches, activeDan, isAutoScrolling]);

  useEffect(() => {
    fetchMatches();
  }, [fetchMatches]);

  // Filtriramo utakmice za prikaz: moraju biti za aktivni dan i NE SMIJU biti završene
  const displayedMatches = hideDataMode
    ? []
    : matches.filter((m) => m.match_day === activeDan && !m.is_completed);

  // Provjera jesu li sve utakmice ikada u bazi završene (ovaj dio ostaje isti)
  const sveUtakmiceZavrsene =
    matches.length > 0 && matches.every((m) => m.is_completed);

  if (loading) return <LoaderBox text="Učitavanje rasporeda..." />;

  return (
    <div className="home-raspored-wrapper">
      {/* Navigacija danima */}
      <div className="day-navigation-tabs">
        {DANI_LISTA.map((d) => {
          // Dodatna vizualna naznaka ako je dan "gotov" (sve tekme tog dana is_completed)
          const isDayFinished =
            matches.length > 0 &&
            matches.filter((m) => m.match_day === d).length > 0 &&
            matches
              .filter((m) => m.match_day === d)
              .every((m) => m.is_completed);

          return (
            <button
              key={d}
              className={`${activeDan === d ? "active" : ""} ${isDayFinished ? "day-done" : ""}`}
              onClick={() => {
                setIsAutoScrolling(false);
                setActiveDan(d);
              }}
            >
              {d}
            </button>
          );
        })}
      </div>

      <div className="schedule-content">
        {sveUtakmiceZavrsene ? (
          <div className="raspored-empty">
            <div className="icon-wrapper">
              <i className="fi fi-rs-trophy"></i>
            </div>
            <h3>Turnir je završen!</h3>
            <p>
              Sve utakmice su odigrane. Rezultate pogledajte u tabu Rezultati.
            </p>
          </div>
        ) : displayedMatches.length > 0 ? (
          <div className="matches-grid">
            {displayedMatches.map((m) => (
              <div
                key={m.id}
                id={`match-${m.id}`}
                className="match-card-modern"
              >
                <div className="match-top-info">
                  <span className="group-badge">
                    {m.group_name === "Završnica"
                      ? "Završnica"
                      : `Grupa ${m.group_name}`}
                  </span>
                  <span className="time-badge">{m.match_time}</span>
                </div>

                <div className="teams-display">
                  <div className="team-box">
                    {/*     <img src={m.team_a?.logo_url || ShieldImg} alt="logo" /> */}
                    <span className="team-name">{m.team_a?.name}</span>
                  </div>
                  <div className="vs-circle">VS</div>
                  <div className="team-box">
                    {/*      <img src={m.team_b?.logo_url || ShieldImg} alt="logo" /> */}
                    <span className="team-name">{m.team_b?.name}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="raspored-empty">
            <div className="icon-wrapper">
              <i className="fi fi-rs-calendar-check"></i>
            </div>
            <h3>Sve utakmice su završene za ovaj dan!</h3>
            <p>Odaberite drugi dan ili pogledajte rezultate.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomeRaspored;
